// The improved version of the My Intrivity Application
import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";   

import { 
    getScore, getIcon, getColor, feedback_mapping 
} from './utility.js'
import { a11yStyles, disclosureButton, uniqueId, accessibleTextColor } from './a11y.js';
import { t, Localized } from './i18n.js';

export class IntrivityBehaviorsApp extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            /* Was a styled <div>; now a real heading so the report has a
               navigable structure (WCAG 1.3.1, 2.4.6). Black on #808080 is
               5.3:1, which clears AA. */
            .section-header {
                margin: 0 0 5px 0;
                width: 100%;
                box-sizing: border-box;
                color: black;
                font-size: 1.5em;
                font-weight: normal;
                padding: 15px 10px 10px 30px;
                background-color: gray;
            }
            .section-header .disclosure {
                vertical-align: middle;
                margin-left: 8px;
                padding: 4px;
            }
        `];
    }

    static get properties() {
        return {
            characteristic: { type: Object },
            characterestic_index: { type: Number },
            domain: {type: Object },
            domain_prefix: { type: String },
            report: { type: Object },
            group_report: { type: Object },
            expanded: { type: Boolean },
            printable: { type: Boolean }
        };
    }

    constructor() {
        super();
        this._panelId = uniqueId('behaviors');
        this.getRawScore = this.getRawScore.bind(this);
        this.expanded = false;
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }
    
    getRawScore(i) {
        console.log(this.report[this.domain.code].level_two[this.characterestic_index].behaviors[i].average);
        return this.report[this.domain.code].level_two[this.characterestic_index].behaviors[i].average;
    }
    
    getTeamScore(i) {
        let groups = [];
        if (this.group_report) {
            let max = 1;
            for (let key in this.group_report[this.domain.code].level_two[this.characterestic_index].behaviors[i].responses) {
                if (this.group_report[this.domain.code].level_two[this.characterestic_index].behaviors[i].responses.hasOwnProperty(key)) {
                    let group = {};
                    group.score = Number(key).toFixed(1);
                    group.size = this.group_report[this.domain.code].level_two[this.characterestic_index].behaviors[i].responses[key].length;
                    if (max < group.size) max = group.size;
                    group.weight = this.group_report[this.domain.code].level_two[this.characterestic_index].behaviors[i].responses[key].length * 5;
                    groups.push(group);
                }
            }
            for (let i =0; i < groups.length; i++) {
                groups[i].max = max;
            }
            //let group = {};
            //group.score = this.group_report[this.domain.code].level_two[this.characterestic_index].behaviors[i].average;
            //group.size = this.group_report.users.length;
            //group.weight = 5; //??
            //groups.push(group);
        }
        return groups;
    }   
    
    render() {
        return html`
       
            <h3 class="section-header" style="color: black; background-color: ${this.expanded ? 'whitesmoke': 'white'};">
                ${this.printable ? t('domainDetails.behaviors'): html`
                    ${this.expanded ? t('domainDetails.hideBehaviors') : t('domainDetails.showBehaviors')}
                    ${disclosureButton(this.expanded, t('domainDetails.behaviors'), this._panelId, () => { this.expanded = !this.expanded; })}
                `}
            </h3>
        
            ${this.expanded || this.printable ? html`
                <div id=${this._panelId}>
                ${this.characteristic.behaviors.map((behavior, j)=> html`
                <div style="page-break-inside: avoid;page-break-before:auto; display: grid; grid-template-columns: 1fr 1fr; width: 100%; background-color:  whitesmoke; padding: 10px; padding-top: 15px; padding-left: 30px; padding-right: 30px;">
                    <div style="margin: 10px;">
                        <div style="color: ${accessibleTextColor(this.domain.color)}; font-size: 1.6em; margin-bottom: 20px;">${behavior.name.toUpperCase()}</div>
                        <div style="margin-bottom: 20px;">${behavior.definition}</div>      
                        <div style="margin-bottom: 20px;">${t('domainDetails.sampleItem', { sample: behavior.sample })}</div>
                    </div>
                    <div style="margin: 10px; padding-right: 20px;">
                         <div><intrivity-likert-report .size_max=${this.group_report.num} .right_text=${behavior.right_label} .left_text=${behavior.left_label} .you=${this.getRawScore(j)} .color=${this.domain.color} .groups=${this.getTeamScore(j)} .colorhue=${this.domain.colorhue} .colorsat=${this.domain.colorsat} .colorlight=${this.domain.colorlight + 15.0}></intrivity-likert-report></div>
                         <div style="margin: 5%;">${behavior.meaning[feedback_mapping[getScore(this.getRawScore(j)) - 1]]}</div>
                     </div>
                </div>
                `)}
                </div>
            `: html``}
        `;
    } 
 
}
if (!customElements.get('intrivity-behaviors')) customElements.define('intrivity-behaviors', IntrivityBehaviorsApp);
